export const reactSelectStyle = {
  indicatorsContainer: styles => ({
    ...styles,
    // display: "none"
  }),
  control: styles => {
    return {
      ...styles,
      backgroundColor: '#fff',
      borderStyle: styles.none,
      ':hover': {
        ...styles[':hover'],
        borderStyle: styles.none,
      }
    };
  },
  option: styles => ({
    ...styles,
    color: "black",
    cursor: "pointer"
  }),
  multiValueRemove: styles => ({
    ...styles,
    cursor: "pointer",
    ':hover': {
      ...styles[":hover"],
      backgroundColor: "#1b67db",
      color: 'white',
    },
  }),
  loadingIndicator: styles => ({
    ...styles,
    ' > span': {
      width: '.5em',
      height: '.5em',
      marginLeft: '2px'
    }
  }),
  dropdownIndicator: styles => ({
    ...styles,
    display: 'none',
  })
};

